// src/components/StepContentContainer.js
import React from 'react';
import { Paper } from '@mui/material';

const StepContentContainer = ({ children }) => {
    return (
        <Paper
            elevation={3}
            sx={{
                maxWidth: 800,
                mx: 'auto',
                mt: 2,
                p: 3,
                textAlign: 'center'
            }}
        >
            {children}
        </Paper>
    );
};

export default StepContentContainer;
